import * as UserActions from "../actions/user";

const initialState = {
  users: [],
  user: null,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case UserActions.ACTION_SAVE_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case UserActions.ACTION_SAVE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case UserActions.ACTION_TOGGLE_USER_ACTIVE:
      // eslint-disable-next-line no-case-declarations
      let foundIndex = state.users.rows.findIndex(x => x.id === action.payload);
      state.users.rows[foundIndex].isActive =
        !state.users.rows[foundIndex].isActive;
      return {
        ...state,
      };
    default:
      return state;
  }
}

export function getUsers(state) {
  return state.user.users;
}
export function getUser(state) {
  return state.user.user;
}
